import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import { patchComponent, useSlots, useConfigInject } from '../_use';
import Indicator, { SIZE_MAP } from './Indicator';
import Locale from '../locale';
import { debounce } from 'lodash-unified';
import ConfigProviderMixin from '../_mixin/config-provider';
const {
  t
} = Locale.create('loading');
function shouldDelay(loading, delay) {
  return !!loading && !!delay && !isNaN(Number(delay));
}
const loadingProps = {
  delay: {
    type: Number
  },
  closeNoDelay: {
    type: Boolean,
    default: false
  },
  size: {
    type: [String, Number]
  },
  color: {
    type: String
  },
  loading: {
    type: Boolean,
    default: true
  },
  tip: {
    type: String,
    default: ''
  },
  tipPlacement: {
    type: String,
    default: 'auto',
    validator(v) {
      var _context;
      return _includesInstanceProperty(_context = ['auto', 'bottom', 'right']).call(_context, v);
    }
  },
  loadingClass: {
    type: String,
    default: ''
  }
};
const UiLoading = patchComponent({
  name: 'UiLoading',
  props: loadingProps,
  mixins: [ConfigProviderMixin],
  data() {
    const {
      loading,
      delay
    } = this;
    const shouldBeDelayed = shouldDelay(loading, delay);
    return {
      sLoading: loading && !shouldBeDelayed,
      originUpdateLoading: null
    };
  },
  computed: {
    class() {
      if (typeof this._size === 'number') {
        return '';
      } else if (typeof this._size === 'string') {
        if (this._size in SIZE_MAP) {
          return "ui-indicator--".concat(this._size);
        } else {
          return "ui-indicator--middle";
        }
      } else {
        return "ui-indicator--middle";
      }
    },
    _size() {
      const {
        size
      } = useConfigInject(this, this.$options.name);
      return this.size || size.value || 'middle';
    },
    tipStyle() {
      const style = {};
      if (this.color) {
        style.color = this.color;
      }
      if (this._size === 'large' || this._size >= SIZE_MAP.large) {
        style.fontSize = '14px';
        style.marginTop = '4px';
      }
      return style;
    },
    finalTipPlacement() {
      let placement = this.tipPlacement;
      if (placement === 'auto') {
        this._size === 'small' ? placement = 'right' : placement = 'bottom';
      }
      return placement;
    },
    tipClassName() {
      const cls = {
        'ui-loading-tip': true,
        ["ui-loading-tip--".concat(this.finalTipPlacement)]: true
      };
      return cls;
    },
    indicatorClassName() {
      const cls = {
        'ui-loading-indicator': true,
        'ui-loading-indicator--running': this.sLoading,
        [this.class]: true
      };
      return cls;
    },
    contClassName() {
      const cls = {
        'ui-loading-container': true,
        'ui-loading-container--blur': this.sLoading
      };
      return cls;
    },
    wrapperClassName() {
      const cls = {
        'ui-loading-indicator-wrapper': true,
        'ui-loading-indicator-wrapper-hidden': !this.sLoading
      };
      return cls;
    }
  },
  updated() {
    this.$nextTick(() => {
      this.debouncifyUpdateLoading();
      this.updateLoading();
      // 是否立即关闭
      if (!this.loading && this.sLoading && this.closeNoDelay) {
        const {
          updateLoading
        } = this;
        updateLoading && updateLoading.flush && updateLoading.flush();
      }
    });
  },
  methods: {
    updateLoading() {
      const {
        loading
      } = this;
      if (loading !== this.sLoading) {
        this.sLoading = loading;
      }
    },
    debouncifyUpdateLoading() {
      const {
        delay
      } = this.$props;
      this.cancelExistingLoading();
      if (delay) {
        this.updateLoading = debounce(this.originUpdateLoading, delay);
      } else {
        this.updateLoading = this.originUpdateLoading;
      }
    },
    cancelExistingLoading() {
      const {
        updateLoading
      } = this;
      updateLoading && updateLoading.cancel && updateLoading.cancel();
    }
  },
  created() {
    this.originUpdateLoading = this.updateLoading;
    this.debouncifyUpdateLoading();
  },
  mounted() {
    this.updateLoading();
  },
  beforeUnmount() {
    this.cancelExistingLoading();
  },
  render() {
    const h = arguments[0];
    const slots = useSlots(this);
    const genIndicatorElement = isNested => {
      let indicatorClassName = this.indicatorClassName;
      if (this.loadingClass) {
        indicatorClassName = _Object$assign({}, indicatorClassName, {
          [this.loadingClass]: !isNested
        });
      }
      const bottom = () => {
        if (slots.text) {
          return h("p", {
            "class": this.tipClassName,
            "style": this.tipStyle
          }, [slots.text()]);
        } else {
          return this.tip ? h("p", {
            "class": this.tipClassName,
            "style": this.tipStyle
          }, [t(this.tip) || this.tip]) : '';
        }
      };
      return h("div", {
        "class": indicatorClassName
      }, [!slots.indicator ? h(Indicator, {
        "attrs": {
          "size": this._size,
          "color": this.color,
          "aria-hidden": "true"
        }
      }) : slots.indicator(), bottom()]);
    };
    if (!slots.default) {
      return genIndicatorElement(false);
    } else {
      const ContainerElement = h("div", {
        "class": this.contClassName
      }, [slots.default()]);
      return h("div", {
        "class": ['ui-loading-wrapper', this.loadingClass]
      }, [h("div", {
        "class": this.wrapperClassName
      }, [genIndicatorElement(true)]), ContainerElement]);
    }
  }
});
export default UiLoading;